package com.appsyde.shared.presentation.style.style

import com.appsyde.shared.presentation.style.token.AppStylesTokens
import org.jetbrains.compose.web.css.*

object AppStylesInboxEmpty : StyleSheet() {

    val emptyRoot by style {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        justifyContent(JustifyContent.Center)
        alignItems(AlignItems.Center)
        padding(48.px, 32.px)
        height(100.percent)
        property("box-sizing", "border-box")
    }

    /** Icône sans fond : juste l’emoji, discrète et lisible. */
    val iconWrap by style {
        display(DisplayStyle.Flex)
        justifyContent(JustifyContent.Center)
        alignItems(AlignItems.Center)
        fontSize(48.px)
        property("line-height", "1")
        opacity(0.92)
    }

    val title by style {
        marginTop(20.px)
        fontSize(22.px)
        fontWeight(650)
        property("letter-spacing", "-0.02em")
        color(Color("rgba(15,23,42,0.88)"))
    }

    val subtitle by style {
        marginTop(12.px)
        fontSize(15.px)
        textAlign("center")
        fontWeight(400)
        color(Color("rgba(55,65,81,0.78)"))
        maxWidth(420.px)
        lineHeight("1.6")
    }

    val primaryButton by style {
        marginTop(28.px)
        padding(14.px, 26.px)
        borderRadius(12.px)
        fontSize(15.px)
        fontWeight(600)
        color(Color.white)
        backgroundColor(Color(AppStylesTokens.BRAND))
        border(0.px)
        property("cursor", "pointer")
        property("letter-spacing", "-0.01em")
        property("transition", "background-color 0.2s ease")
        self + hover style { backgroundColor(Color(AppStylesTokens.NAV_ACTIVE)) }
    }
}
